module.exports = __webpack_public_path__ + "static/media/Layout7.020ddd69.png";